module.exports = __webpack_public_path__ + "static/media/51.64a1f9b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/51.jpg
// module id = 612
// module chunks = 0